import React, { FunctionComponent, useState } from "react";

import {
  Dialog,
  SubmissionForm,
  TextInputField,
  FieldSpy
} from "@bps/fluent-ui";
import { useCreateCertificate } from "@libs/api/gateways/plt-integrators/plt-integrators-gateway.hooks";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { Validator } from "@bps/validator";

export interface RegisterCertificateDialogProps {
  tenant: Tenant;
  onDismiss: () => void;
}

export interface RegisterCertificateFormValues {
  content: string;
}

const registerCertificateValidator = new Validator<
  RegisterCertificateFormValues
>(validator => ({
  content: validator.string().required({ message: "File is required" })
}));

export const RegisterCertificateDialog: FunctionComponent<RegisterCertificateDialogProps> = ({
  tenant,
  onDismiss
}) => {
  const { mutateAsync: createCertificate } = useCreateCertificate();

  const onSubmit = async () => {
    if (!file) return;
    await createCertificate({
      content: await file.text(), //.Cer files are base64 encoded
      tenantId: tenant.id
    });
    onDismiss();
  };

  const [file, setFile] = useState<File>();

  const defaultValues = {
    content: ""
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        title: "Register Public Certificate",
        showCloseButton: true,
        onDismiss
      }}
      minWidth={450}
    >
      <SubmissionForm<RegisterCertificateFormValues>
        onSubmit={onSubmit}
        initialValues={defaultValues}
        submitButtonProps={{ text: "Upload" }}
        validate={registerCertificateValidator.validate}
        cancelButtonProps={{ onClick: onDismiss }}
      >
        {() => (
          <>
            <TextInputField
              name="content"
              type="File"
              label="Name (.cer extensions only)"
              required
              accept=".cer,application/pkix-cert"
            />
            <FieldSpy
              name="content"
              onChange={files => {
                if (files && files?.length > 0) {
                  setFile(files[0]);
                }
              }}
            />
          </>
        )}
      </SubmissionForm>
    </Dialog>
  );
};
